declare namespace $ {

	type $mol_string_button__value_shm_hitalama_map_editor_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['title'] >
		,
		ReturnType< $mol_string_button['value'] >
	>
	type $mol_check_box__title_shm_hitalama_map_editor_2 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check_box['title'] >
	>
	type $mol_check_box__checked_shm_hitalama_map_editor_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['hide_head_tools'] >
		,
		ReturnType< $mol_check_box['checked'] >
	>
	type $mol_textarea__value_shm_hitalama_map_editor_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['description'] >
		,
		ReturnType< $mol_textarea['value'] >
	>
	type $mol_form_field__name_shm_hitalama_map_editor_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_editor_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['Description_edit'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $shm_hitalama_select_list__value_shm_hitalama_map_editor_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['tags'] >
		,
		ReturnType< $shm_hitalama_select_list['value'] >
	>
	type $shm_hitalama_select_list__options_shm_hitalama_map_editor_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['used_tags'] >
		,
		ReturnType< $shm_hitalama_select_list['options'] >
	>
	type $mol_form_field__name_shm_hitalama_map_editor_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__Content_shm_hitalama_map_editor_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['Tags_edit'] >
		,
		ReturnType< $mol_form_field['Content'] >
	>
	type $mol_text__text_shm_hitalama_map_editor_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_editor_12 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_editor_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['widget_cut'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__title_shm_hitalama_map_editor_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['title'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_editor_15 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['cut_cancel'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__sub_shm_hitalama_map_editor_16 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_pick__align_shm_hitalama_map_editor_17 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__showed_shm_hitalama_map_editor_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['cut_bubble_showed'] >
		,
		ReturnType< $mol_pick['showed'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_map_editor_19 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_editor_20 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_list__sub_shm_hitalama_map_editor_21 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_list['sub'] >
	>
	type $mol_pick__hint_shm_hitalama_map_editor_22 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_map_editor_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_map_editor_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__no_crdt_shm_hitalama_map_editor_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['code_no_crdt'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['no_crdt'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__code_download_blob_shm_hitalama_map_editor_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['code_download_blob'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['code_download_blob'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__code_download_file_name_shm_hitalama_map_editor_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['code_download_file_name'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['code_download_file_name'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__template_dictionary_shm_hitalama_map_editor_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['template_dictionary'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['template_dictionary'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__template_selected_shm_hitalama_map_editor_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['template_selected'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['template_selected'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__enabled_shm_hitalama_map_editor_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['code_enabled'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['enabled'] >
	>
	type $shm_hitalama_map_widget_float_code_panel__run_click_shm_hitalama_map_editor_31 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['run_click'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_code_panel['run_click'] >
	>
	type $mol_view__sub_shm_hitalama_map_editor_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['widget_code_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_scroll__sub_shm_hitalama_map_editor_33 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_scroll['sub'] >
	>
	type $mol_page__head_shm_hitalama_map_editor_34 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['head'] >
	>
	type $mol_page__body_shm_hitalama_map_editor_35 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_editor_36 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_editor_37 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['preview_pin'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_editor_38 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_editor_39 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['preview_unpin'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__hint_shm_hitalama_map_editor_40 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_hitalama_map_editor_41 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_hitalama_map_editor_42 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_editor['preview_reload'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $shm_hitalama_page__resize_side_shm_hitalama_map_editor_43 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_page['resize_side'] >
	>
	type $shm_hitalama_page__width_max_shm_hitalama_map_editor_44 = $mol_type_enforce<
		number
		,
		ReturnType< $shm_hitalama_page['width_max'] >
	>
	type $shm_hitalama_page__head_shm_hitalama_map_editor_45 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_page['head'] >
	>
	type $shm_hitalama_page__body_shm_hitalama_map_editor_46 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_hitalama_page['body'] >
	>
	export class $shm_hitalama_map_editor extends $mol_book2 {
		autobackup( next?: any ): any
		Title( ): $mol_string_button
		Settings_trigger_icon( ): $mol_icon_dots_vertical
		hide_head_tools( next?: boolean ): boolean
		Hide_head_tools( ): $mol_check_box
		description( next?: string ): string
		Description_edit( ): $mol_textarea
		Description_field( ): $mol_form_field
		tags( next?: readonly(string)[] ): readonly(string)[]
		used_tags( next?: readonly(string)[] ): readonly(string)[]
		Tags_edit( ): $shm_hitalama_select_list
		Tags_field( ): $mol_form_field
		cut_bubble_showed( next?: boolean ): boolean
		Cut_icon( ): $mol_icon_trash_can
		Cut_text( ): $mol_text
		widget_cut( next?: any ): any
		Cut_yes( ): $mol_button_minor
		cut_cancel( next?: any ): any
		Cut_no( ): $mol_button_minor
		Cut_bubble( ): $mol_view
		Cut_pick( ): $mol_pick
		Settings_content( ): $mol_list
		Settings( ): $mol_pick
		Settings_free_space( ): $mol_view
		code_no_crdt( ): boolean
		code_download_blob( ): any
		code_download_file_name( ): string
		template_dictionary( ): Record<string, any>
		template_selected( next?: string ): string
		code_enabled( next?: boolean ): boolean
		run_click( next?: any ): any
		Code_panel( ): $shm_hitalama_map_widget_float_code_panel
		widget_code_content( ): readonly(any)[]
		Widget_code_content( ): $mol_view
		Widget_content( ): $mol_scroll
		Edit_page( ): $mol_page
		edit_page( ): readonly(any)[]
		Pin_icon( ): $mol_icon_pin
		preview_pin( next?: any ): any
		Pin( ): $mol_button_minor
		Unpin_icon( ): $mol_icon_pin_off
		preview_unpin( next?: any ): any
		Unpin( ): $mol_button_minor
		Preview_reload_icon( ): $mol_icon_refresh
		preview_reload( next?: any ): any
		Preview_reload( ): $mol_button_minor
		Preview_fullscreen( ): $mol_view
		preview_head( ): readonly(any)[]
		Preview_content( ): $mol_view
		Preview_page( ): $shm_hitalama_page
		preview_page( ): readonly(any)[]
		map( ): $shm_hitalama_map
		widget( ): $shm_hitalama_map_widget
		Widget( id: any): $shm_hitalama_map_widget_any
		auto( ): readonly(any)[]
		selected_links( next?: readonly(any)[] ): readonly(any)[]
		go_to_frame_by_num( id: any): any
		set_frame( id: any): any
		widgets_filtered( ): readonly($shm_hitalama_map_widget)[]
		placeholders( ): readonly(any)[]
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=editor.view.tree.d.ts.map